import { useRouteError } from "react-router-dom";
import { useDocumentTitle } from "../../hooks/useDocumentTitle";
import css from "./ErrorPage.module.css";

function ErrorPage() {
  const error: unknown = useRouteError();
  console.error(error);

  useDocumentTitle("Error");

  return (
    <div className={css.infoText}>
      Something went wrong trying to display this page. Please try reloading the
      page. If that still fails, contact Unruly support at&nbsp;
      <a href="mailto:accounts@unrulycorp.com">accounts@unrulycorp.com</a>.
    </div>
  );
}

export default ErrorPage;
